import { Data, ProductGridProps } from '@typings/productGrid';
import PaginatedGrid, { type GridLifestyleCard } from '@repo/ui/src/components/PaginatedGrid';
import LoadingLogo from '@components/Loading/LoadingLogo';

export enum GridType {
  Product = 'Product',
  Learn = 'Learn',
  Recipe = 'Recipe',
  TraegerTv = 'Traeger TV',
  Ambassador = 'Ambassador',
  Story = 'Story',
}

interface AppPaginatedGridProps extends Partial<
  Pick<
    ProductGridProps,
    'content' | 'showFinancing' | 'hideAddToCartButton' | 'financingText' | 'hideDiscount'
  >
> {
  gridLifestyleCard?: GridLifestyleCard;
  items?: Array<any>;
  nbPages?: number;
  page?: number;
  _data?: Data;
  loadData: (params: { page: number }, controller: AbortController, offset: number) => Promise<any>;
  type: GridType;
  content?: any;
  GridItemComponent: any;
  isLoading?: boolean;
  className?: string;
  disableBorder?: boolean;
  darkBackground?: boolean;
  isItemHidden?: (item: any) => boolean;
}

const AppPaginatedGrid = ({
  gridLifestyleCard,
  items,
  nbPages,
  page,
  _data,
  loadData,
  content,
  GridItemComponent,
  className,
  hideAddToCartButton,
  hideDiscount,
  showFinancing,
  financingText,
  isLoading = false,
  disableBorder = false,
  darkBackground = false,
  isItemHidden,
}: AppPaginatedGridProps) => (
  <PaginatedGrid
    gridLifestyleCard={gridLifestyleCard}
    items={items}
    nbPages={nbPages}
    page={page}
    _data={_data}
    loadData={loadData}
    content={content}
    GridItemComponent={GridItemComponent}
    className={className}
    itemClassName={disableBorder ? undefined : 'border border-warm-200'}
    hideAddToCartButton={hideAddToCartButton}
    hideDiscount={hideDiscount}
    showFinancing={showFinancing}
    financingText={financingText}
    isLoading={isLoading}
    loadingSlot={<LoadingLogo />}
    darkBackground={darkBackground}
    isItemHidden={isItemHidden}
  />
);

export default AppPaginatedGrid;
